export default "__VITE_ASSET__649c4da0__"